import { render, staticRenderFns } from "./vlogs.vue?vue&type=template&id=3a973048&scoped=true&"
import script from "./vlogs.vue?vue&type=script&lang=js&"
export * from "./vlogs.vue?vue&type=script&lang=js&"
import style0 from "./vlogs.vue?vue&type=style&index=0&id=3a973048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a973048",
  null
  
)

export default component.exports